import {JsonProperty} from '@dhkatz/json-ts';
import {ArrayNumberConverter} from '../../../../../../../../globals/api/json/array-number-converter';
import {VectorBorderElement} from '../interfaces/vector-border-element';
import {Gradient} from '../models/gradient';
import {VectorFillElement} from './vector-fill-element';

export class VectorFillBorderElement extends VectorFillElement implements VectorBorderElement {

  @JsonProperty('sS')
  private _strokeStyle: string;

  @JsonProperty({name: 'sG', type: Gradient})
  private _strokeGradient: Gradient;

  @JsonProperty('lW')
  private _lineWidth: number;

  @JsonProperty({name: 'dA', converter: ArrayNumberConverter.converter, type: Object})
  private _dashArray: number[];

  public constructor() {
    super();
    this._strokeStyle = undefined;
    this._strokeGradient = undefined;
    this._lineWidth = undefined;
    this._dashArray = undefined;
  }

  public get strokeStyle(): string {
    return this._strokeStyle;
  }

  public get strokeGradient(): Gradient {
    return this._strokeGradient;
  }

  public get lineWidth(): number {
    return this._lineWidth;
  }

  public get dashArray(): number[] {
    return this._dashArray;
  }
}
